import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserEventHistoryType } from "../slices/userEventHistory";
import GrafanaClient from "../../config/grafanaClient";
import { setLoader } from "../slices/authSlice";

export const storeUserEventHistory = createAsyncThunk("storeUserEventHistory", async (req: UserEventHistoryType, { dispatch }) => {
    try {
        await GrafanaClient().post('/tenant-report/save-ieq-gpt-history', req);
    } catch (error) {
        console.log("error ", error);
    }
});

export const getUserEventHistory = createAsyncThunk("getUserEventHistory", async (_request: { tenantId: string, toDate?: number, fromDate?: number }, { dispatch, rejectWithValue }) => {
    dispatch(setLoader(true));
    try {
        const response = await GrafanaClient().post(`/tenant-report/get-ieq-gpt-history`, { tenantId: _request?.tenantId, fromDate: _request?.fromDate, toDate: _request?.toDate });
        dispatch(setLoader(false));
        if (response?.data) {
            return response.data;
        }
        rejectWithValue([]);
    } catch (error) {
        dispatch(setLoader(false));
        rejectWithValue([]);
        console.log("hello ", error);
    }
})
